import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AllFullClass;
function AllFull() {
  if (AllFullClass === VOID) {
    class $ {
      hdb(layout, inProgress, within) {
        return within;
      }
      idb(layout, inProgress, within) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = layout.oba().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          inProgress.jdb(element, 0.0, 0.0, within.td0_1, within.ud0_1);
        }
      }
    }
    initMetadataForObject($, 'AllFull');
    AllFullClass = $;
  }
  return AllFullClass;
}
var AllFull_instance;
function AllFull_getInstance() {
  return AllFull_instance;
}
//region block: init
AllFull_instance = new (AllFull())();
//endregion
//region block: exports
export {
  AllFull_instance as AllFull_instance2nn1g6bx2959d,
};
//endregion

//# sourceMappingURL=ProgrammaticLayout.mjs.map
